// Auto-generated file created by svgr-cli source svg-template.js
// Run yarn icons:create to update
// Do not edit
import * as React from 'react';
const SvgCheckCircle = (props) => (React.createElement("svg", Object.assign({ width: props.width || 50, height: props.height || 50, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m7.5 12 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z", stroke: props.color || `#000000`, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
export default SvgCheckCircle;
